import React, {
    useState,
    useEffect,
    useReducer,
    useCallback,
    useContext,
} from "react";
import { toast } from "react-toastify";

import { makeStyles, useTheme } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Button from "@material-ui/core/Button";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import IconButton from "@material-ui/core/IconButton";
import SearchIcon from "@material-ui/icons/Search";
import TextField from "@material-ui/core/TextField";
import InputAdornment from "@material-ui/core/InputAdornment";
import Typography from "@material-ui/core/Typography";
// import Box from "@material-ui/core/Box"; // ✅ REMOVIDO: No se usa en la página principal
import Chip from "@material-ui/core/Chip";
// import Avatar from "@material-ui/core/Avatar"; // ✅ REMOVIDO: No se usa
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
// ✅ ICONOS MOVIDOS AL MODAL FileModal
// import InsertDriveFileIcon from "@material-ui/icons/InsertDriveFile";
// import PictureAsPdfIcon from "@material-ui/icons/PictureAsPdf";
// import DescriptionIcon from "@material-ui/icons/Description";
// import VideoLibraryIcon from "@material-ui/icons/VideoLibrary";
// import MusicNoteIcon from "@material-ui/icons/MusicNote";
// import ImageIcon from "@material-ui/icons/Image";

import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";
import EditIcon from "@material-ui/icons/Edit";

import MainContainer from "../../components/MainContainer";
import MainHeader from "../../components/MainHeader";
import MainHeaderButtonsWrapper from "../../components/MainHeaderButtonsWrapper";
import Title from "../../components/Title";

import api from "../../services/api";
import { i18n } from "../../translate/i18n";
import TableRowSkeleton from "../../components/TableRowSkeleton";
import FileModal from "../../components/FileModal";
import ConfirmationModal from "../../components/ConfirmationModal";
import toastError from "../../errors/toastError";
import { SocketContext } from "../../context/Socket/SocketContext";
import { AuthContext } from "../../context/Auth/AuthContext";

const reducer = (state, action) => {
    if (action.type === "LOAD_FILES") {
        const files = action.payload;
        const newFiles = [];

        files.forEach((fileList) => {
            const fileListIndex = state.findIndex((s) => s.id === fileList.id);
            if (fileListIndex !== -1) {
                state[fileListIndex] = fileList;
            } else {
                newFiles.push(fileList);
            }
        });

        return [...state, ...newFiles];
    }

    if (action.type === "UPDATE_FILES") {
        const fileList = action.payload;
        const fileListIndex = state.findIndex((s) => s.id === fileList.id);

        if (fileListIndex !== -1) {
            state[fileListIndex] = fileList;
            return [...state];
        } else {
            return [fileList, ...state];
        }
    }

    if (action.type === "DELETE_TAG") {
        const fileListId = action.payload;

        const fileListIndex = state.findIndex((s) => s.id === fileListId);
        if (fileListIndex !== -1) {
            state.splice(fileListIndex, 1);
        }
        return [...state];
    }

    if (action.type === "RESET") {
        return [];
    }
};

const useStyles = makeStyles((theme) => ({
    // ✅ CORREGIDO: MainPaper dinámico según tema
    mainPaper: {
        flex: 1,
        padding: theme.spacing(2),
        overflowY: "scroll",
        ...theme.scrollbarStyles,
        borderRadius: '12px',
        boxShadow: theme.mode === 'dark' ? '0 4px 20px rgba(0,0,0,0.3)' : '0 4px 20px rgba(0,0,0,0.08)',
        backgroundColor: theme.mode === 'dark' ? '#1f2937' : '#fafafa',
        border: `1px solid ${theme.mode === 'dark' ? '#4B5563' : '#e0e0e0'}`,
    },
    // ✅ CABECERA AZUL DEL SISTEMA MEJORADA
    tableHeader: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
        fontWeight: 'bold',
        fontSize: '0.875rem',
        borderRadius: '8px 8px 0 0',
    },
    tableHeaderCell: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
        fontWeight: 'bold',
        fontSize: '0.875rem',
        borderBottom: `1px solid ${theme.palette.primary.dark}`,
        padding: '16px 12px',
    },
    formatChip: {
        fontSize: '0.75rem',
        height: '28px',
        borderRadius: '14px',
        fontWeight: '600',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
    },
    dateText: {
        fontSize: '0.875rem',
        color: theme.palette.text.secondary,
        fontWeight: '500',
    },
    // ✅ CORREGIDO: TableRow dinámico según tema
    tableRow: {
        backgroundColor: theme.palette.background.paper,
        '&:hover': {
            backgroundColor: theme.mode === 'dark' ? '#374151' : '#f5f5f5',
            transform: 'translateY(-1px)',
            boxShadow: theme.mode === 'dark' ? '0 2px 8px rgba(0,0,0,0.3)' : '0 2px 8px rgba(0,0,0,0.1)',
            transition: 'all 0.2s ease-in-out',
        },
        transition: 'all 0.2s ease-in-out',
        borderRadius: '4px',
        margin: '2px 0',
        '& td': {
            color: theme.palette.text.primary,
            borderBottom: `1px solid ${theme.mode === 'dark' ? '#374151' : '#e0e0e0'}`,
        },
    },
    actionButton: {
        margin: '0 4px',
        padding: '8px',
        borderRadius: '50%',
        transition: 'all 0.2s ease-in-out',
        '&:hover': {
            transform: 'scale(1.1)',
            boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
        },
    },
    editButton: {
        backgroundColor: '#2196f3',
        color: 'white',
        '&:hover': {
            backgroundColor: '#1976d2',
        },
    },
    deleteButton: {
        backgroundColor: '#f44336',
        color: 'white',
        '&:hover': {
            backgroundColor: '#d32f2f',
        },
    },
    // ✅ CORREGIDO: SearchField dinámico según tema
    searchField: {
        '& .MuiOutlinedInput-root': {
            borderRadius: '25px',
            backgroundColor: theme.mode === 'dark' ? '#374151' : 'white',
            color: theme.palette.text.primary,
            boxShadow: theme.mode === 'dark' ? '0 2px 8px rgba(0,0,0,0.3)' : '0 2px 8px rgba(0,0,0,0.1)',
            '&:hover': {
                boxShadow: theme.mode === 'dark' ? '0 4px 12px rgba(0,0,0,0.4)' : '0 4px 12px rgba(0,0,0,0.15)',
            },
            '&.Mui-focused': {
                boxShadow: `0 4px 12px ${theme.mode === 'dark' ? 'rgba(59, 130, 246, 0.4)' : 'rgba(25, 118, 210, 0.3)'}`,
            },
            "& fieldset": {
                borderColor: theme.mode === 'dark' ? '#4B5563' : '#e0e0e0',
            },
            "&:hover fieldset": {
                borderColor: theme.palette.primary.main,
            },
            "&.Mui-focused fieldset": {
                borderColor: theme.palette.primary.main,
            },
        },
        "& .MuiInputLabel-root": {
            color: theme.palette.text.secondary || theme.palette.text.primary,
        },
        "& .MuiInputLabel-root.Mui-focused": {
            color: theme.palette.primary.main,
        },
    },
    newFileButton: {
        borderRadius: '25px',
        padding: '12px 24px',
        fontWeight: '600',
        textTransform: 'none',
        fontSize: '0.9rem',
        boxShadow: '0 4px 12px rgba(25, 118, 210, 0.3)',
        '&:hover': {
            transform: 'translateY(-2px)',
            boxShadow: '0 6px 16px rgba(25, 118, 210, 0.4)',
        },
        transition: 'all 0.2s ease-in-out',
    },
    titleContainer: {
        display: 'flex',
        alignItems: 'center',
        marginBottom: theme.spacing(2),
    },
    titleIcon: {
        marginRight: theme.spacing(1),
        fontSize: '1.5rem',
        color: theme.palette.primary.main,
    },
    fileCountBadge: {
        marginLeft: theme.spacing(1),
        backgroundColor: theme.palette.primary.main,
        color: 'white',
        borderRadius: '12px',
        padding: '4px 8px',
        fontSize: '0.75rem',
        fontWeight: '600',
    },
    dragDropZone: {
        border: `2px dashed ${theme.palette.primary.main}`,
        borderRadius: theme.spacing(2),
        padding: theme.spacing(4),
        textAlign: "center",
        backgroundColor: theme.palette.primary.light + "10",
        marginBottom: theme.spacing(2),
        cursor: "pointer",
        transition: "all 0.3s ease",
        "&:hover": {
            backgroundColor: theme.palette.primary.light + "20",
            borderColor: theme.palette.primary.dark,
        },
        "&.dragActive": {
            backgroundColor: theme.palette.primary.light + "30",
            borderColor: theme.palette.primary.dark,
            transform: "scale(1.02)",
        },
    },
    dragDropIcon: {
        fontSize: 48,
        color: theme.palette.primary.main,
        marginBottom: theme.spacing(2),
    },
    dragDropText: {
        color: theme.palette.text.secondary,
        marginBottom: theme.spacing(1),
    },
    dragDropSubtext: {
        color: theme.palette.text.disabled,
        fontSize: "0.875rem",
    },
    fileIcon: {
        width: 40,
        height: 40,
        backgroundColor: theme.palette.grey[100],
    },
    fileIconPdf: {
        backgroundColor: "#f44336",
        color: "white",
    },
    fileIconDoc: {
        backgroundColor: "#2196f3",
        color: "white",
    },
    fileIconImage: {
        backgroundColor: "#4caf50",
        color: "white",
    },
    fileIconVideo: {
        backgroundColor: "#ff9800",
        color: "white",
    },
    fileIconAudio: {
        backgroundColor: "#9c27b0",
        color: "white",
    },
    fileIconDefault: {
        backgroundColor: theme.palette.grey[400],
        color: "white",
    },
}));

const FileLists = () => {
    const classes = useStyles();
    const theme = useTheme();

    const { user } = useContext(AuthContext);

    const [loading, setLoading] = useState(false);
    const [pageNumber, setPageNumber] = useState(1);
    const [hasMore, setHasMore] = useState(false);
    const [selectedFileList, setSelectedFileList] = useState(null);
    const [deletingFileList, setDeletingFileList] = useState(null);
    const [confirmModalOpen, setConfirmModalOpen] = useState(false);
    const [searchParam, setSearchParam] = useState("");
    const [files, dispatch] = useReducer(reducer, []);
    const [fileListModalOpen, setFileListModalOpen] = useState(false);
    // const [dragActive, setDragActive] = useState(false); // ✅ REMOVIDO: Se usa solo en el modal
    // const [uploadingFiles, setUploadingFiles] = useState(false); // ✅ REMOVIDO: No se usa actualmente

    // ✅ FUNCIONES DE UTILIDAD MOVIDAS AL MODAL FileModal

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        return date.toLocaleDateString('es-ES', {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        });
    };

    // ✅ FUNCIONES DE DRAG & DROP MOVIDAS AL MODAL FileModal

    const fetchFileLists = useCallback(async () => {
        try {
            const { data } = await api.get("/files/", {
                params: { searchParam, pageNumber },
            });
            dispatch({ type: "LOAD_FILES", payload: data.files });
            setHasMore(data.hasMore);
            setLoading(false);
        } catch (err) {
            toastError(err);
        }
    }, [searchParam, pageNumber]);

    const socketManager = useContext(SocketContext);

    useEffect(() => {
        dispatch({ type: "RESET" });
        setPageNumber(1);
    }, [searchParam]);

    useEffect(() => {
        setLoading(true);
        const delayDebounceFn = setTimeout(() => {
            fetchFileLists();
        }, 500);
        return () => clearTimeout(delayDebounceFn);
    }, [searchParam, pageNumber, fetchFileLists]);

    useEffect(() => {
        const socket = socketManager.getSocket(user.companyId);

        socket.on(`company-${user.companyId}-file`, (data) => {
            if (data.action === "update" || data.action === "create") {
                dispatch({ type: "UPDATE_FILES", payload: data.files });
            }

            if (data.action === "delete") {
                dispatch({ type: "DELETE_USER", payload: +data.fileId });
            }
        });

        return () => {
            socket.disconnect();
        };
    }, [socketManager, user]);

    const handleOpenFileListModal = () => {
        setSelectedFileList(null);
        setFileListModalOpen(true);
    };

    const handleCloseFileListModal = () => {
        setSelectedFileList(null);
        setFileListModalOpen(false);
    };

    const handleSearch = (event) => {
        setSearchParam(event.target.value.toLowerCase());
    };

    const handleEditFileList = (fileList) => {
        setSelectedFileList(fileList);
        setFileListModalOpen(true);
    };

    const handleDeleteFileList = async (fileListId) => {
        try {
            await api.delete(`/files/${fileListId}`);
            toast.success(i18n.t("files.toasts.deleted"));
        } catch (err) {
            toastError(err);
        }
        setDeletingFileList(null);
        setSearchParam("");
        setPageNumber(1);

        dispatch({ type: "RESET" });
        setPageNumber(1);
        await fetchFileLists();
    };

    const loadMore = () => {
        setPageNumber((prevState) => prevState + 1);
    };

    const handleScroll = (e) => {
        if (!hasMore || loading) return;
        const { scrollTop, scrollHeight, clientHeight } = e.currentTarget;
        if (scrollHeight - (scrollTop + 100) < clientHeight) {
            loadMore();
        }
    };

    return (
        <MainContainer>
            <ConfirmationModal
                title={deletingFileList && `${i18n.t("files.confirmationModal.deleteTitle")}`}
                open={confirmModalOpen}
                onClose={setConfirmModalOpen}
                onConfirm={() => handleDeleteFileList(deletingFileList.id)}
            >
                {i18n.t("files.confirmationModal.deleteMessage")}
            </ConfirmationModal>
            <FileModal
                open={fileListModalOpen}
                onClose={handleCloseFileListModal}
                reload={fetchFileLists}
                aria-labelledby="form-dialog-title"
                fileListId={selectedFileList && selectedFileList.id}
            />
                    <MainHeader>
                        <div className={classes.titleContainer}>
                            <CloudUploadIcon className={classes.titleIcon} />
                            <Title>Administrador de Archivos</Title>
                            <span className={classes.fileCountBadge}>{files.length} listas</span>
                        </div>
                        <MainHeaderButtonsWrapper>
                            <TextField
                                placeholder="Buscar listas de archivos..."
                                type="search"
                                value={searchParam}
                                onChange={handleSearch}
                                className={classes.searchField}
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <SearchIcon style={{ color: "gray" }} />
                                        </InputAdornment>
                                    ),
                                }}
                            />
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={handleOpenFileListModal}
                                startIcon={<CloudUploadIcon />}
                                className={classes.newFileButton}
                            >
                                Nueva Lista de Archivos
                            </Button>
                        </MainHeaderButtonsWrapper>
                    </MainHeader>
            <Paper
                className={classes.mainPaper}
                variant="outlined"
                onScroll={handleScroll}
            >
                {/* ✅ TABLA DE AGRUPACIONES DE ARCHIVOS */}
                <Table size="small">
                    <TableHead>
                        <TableRow className={classes.tableHeader}>
                            <TableCell className={classes.tableHeaderCell}>NOMBRE DE LA LISTA</TableCell>
                            <TableCell className={classes.tableHeaderCell}>DESCRIPCIÓN</TableCell>
                            <TableCell className={classes.tableHeaderCell}>CANTIDAD DE ARCHIVOS</TableCell>
                            <TableCell className={classes.tableHeaderCell}>FECHA DE CREACIÓN</TableCell>
                            <TableCell className={classes.tableHeaderCell} align="center">ACCIONES</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <>
                                {files.map((fileList) => (
                                    <TableRow key={fileList.id} className={classes.tableRow}>
                                        <TableCell>
                                            <Typography variant="body2" noWrap style={{ fontWeight: '600', fontSize: '0.9rem', color: theme.palette.text.primary }}>
                                                {fileList.name}
                                            </Typography>
                                        </TableCell>
                                        <TableCell>
                                            <Typography variant="body2" noWrap style={{ color: theme.palette.text.secondary || theme.palette.text.primary }}>
                                                {fileList.message || 'Sin descripción'}
                                            </Typography>
                                        </TableCell>
                                        <TableCell>
                                            <Chip 
                                                label={`${fileList.options?.length || 0} archivos`}
                                                size="small"
                                                className={classes.formatChip}
                                                color={fileList.options?.length > 0 ? "primary" : "default"}
                                                style={{ 
                                                    backgroundColor: fileList.options?.length > 0 ? '#2196f3' : '#e0e0e0',
                                                    color: fileList.options?.length > 0 ? 'white' : '#666'
                                                }}
                                            />
                                        </TableCell>
                                        <TableCell>
                                            <Typography className={classes.dateText}>
                                                {fileList.createdAt ? formatDate(fileList.createdAt) : 'N/A'}
                                            </Typography>
                                        </TableCell>
                                        <TableCell align="center">
                                            <IconButton 
                                                size="small" 
                                                onClick={() => handleEditFileList(fileList)}
                                                title="Editar lista de archivos"
                                                className={`${classes.actionButton} ${classes.editButton}`}
                                            >
                                                <EditIcon />
                                            </IconButton>
                                            <IconButton
                                                size="small"
                                                onClick={(e) => {
                                                    setConfirmModalOpen(true);
                                                    setDeletingFileList(fileList);
                                                }}
                                                title="Eliminar lista de archivos"
                                                className={`${classes.actionButton} ${classes.deleteButton}`}
                                            >
                                                <DeleteOutlineIcon />
                                            </IconButton>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            {loading && <TableRowSkeleton columns={5} />}
                        </>
                    </TableBody>
                </Table>
            </Paper>
        </MainContainer>
    );
};

export default FileLists;
